import { CATERER_STATUS_LIST } from "../../../../utils/configs";
import { FaRegTimesCircle, FaClock, FaSpinner } from 'react-icons/fa';
import { FaFlag } from 'react-icons/fa6';
import { FaClipboardQuestion } from "react-icons/fa6";
const getOrderStatusColorCode = (params) => {
  if (params) {
    const orderStatus = params.data.status;
    const ordSts = CATERER_STATUS_LIST.find( _ => _.key === orderStatus );
    if (ordSts) {
      return (
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
          { ordSts.value === 'Accepted' && <FaFlag color={ ordSts.colorCode_text } size={14}/> }
          { ordSts.value === 'Rejected' && <FaRegTimesCircle color={ ordSts.colorCode_text } size={14}/> }
          { ordSts.value === 'Clarification' && <FaClipboardQuestion color={ ordSts.colorCode_text } size={14}/> }
          { ordSts.value === 'Under Review' && <FaClock color={ ordSts.colorCode_text } size={14}/> }
          { ordSts.value === 'Processing' && <FaSpinner className="spin-icon" color={ ordSts.colorCode_text } size={14}/> }

          <span style={{ color: ordSts.colorCode_text, fontWeight: 600 }}>{ordSts.value}</span>
        </span>
      );
    }
    else {
      return <>{orderStatus}</>
    }
  }
  return null;
}

export const CateringStatusRenderSel = (props) => {
    let dd = props.data ? getOrderStatusColorCode(props) : null;
    return (
        <div className="orderStatus-renderer">
            {dd}
        </div>
    );
};